module.exports = __webpack_public_path__ + "img/t-shirt.c593f1ab.png";